export function formatAddress(
  { line1, line2 = '', city = '', state = '', zip = '' },
  multiLine,
  mergeAddressLines
) {
  if (mergeAddressLines) {
    line1 = `${line1} ${line2}`;
    line2 = null;
  }

  if (city) city += ',';

  if (multiLine) {
    line1 += '<br>';
    if (line2) line2 += '<br>';
  }

  return [line1, line2, city, state, zip].join(' ').replace('  ', ' ');
}

// const days = [
//   'sunday',
//   'monday',
//   'tuesday',
//   'wednesday',
//   'thursday',
//   'friday',
//   'saturday'
// ];
const days = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

function formatHours(location) {
  const hours = [];

  days.forEach(day => {
    day = day.toLowerCase();
    const openKey = day + 'OpenTime';
    const closeKey = day + 'CloseTime';

    if (location[openKey].length < 4 || location[closeKey].length < 4) {
      hours.push({ open: false });
    } else {
      hours.push({ open: location[openKey], close: location[closeKey] });
    }
  });

  return hours;
}

function getHoursText(hours = {}) {
  if (!hours.open || !hours.hasOwnProperty('close')) return 'Closed';
  return `${parseTime(hours.open)} - ${parseTime(hours.close)}`;
}

function parseTime(time) {
  time = parseInt(time);
  const isPM = time >= 1300;
  const timeText = isPM ? 'PM' : 'AM';

  if (isPM) time -= 1200;
  time = String(time);

  return `${time.slice(0, -2)}:${time.slice(-2)} ${timeText}`;
}

function getHoursHtml(location) {
  if (location.atmOnly || !location.hours || !Array.isArray(location.hours)) {
    return '';
  }

  const dayIndex = new Date().getDay();

  return location.hours
    .map((hours, index) => {
      const className = index === dayIndex ? 'item current' : 'item';

      return `
        <div class="${className}">
          <div class="day">${days[index]}</div>
          <div class="hours">${getHoursText(hours)}</div>
        </div>
      `.trim();
    })
    .join('');
}

// Update the parameters in the image URL so that Kentico
// will resize it appropriately.The width and/or height
// should be passed @2x for retina screens
function getImageSizeUrl(url = '', width, height) {
  url = url?.trim() ?? '';
  if (!url) return url;

  url = url.split('?')[0];
  let separator = '?';

  if (width) {
    url += `?width=${width}`;
    separator = '&';
  }

  if (height) {
    url += `${separator}height=${height}`;
  }

  return url;
}

export function formatData(locations) {
  return locations.reduce((acc, location) => {
    const data = {
      id: location.id,
      name: location.name.trim(),
      address: {
        line1: location.streetAddress.trim(),
        line2: location.streetAddressOptional.trim(),
        city: location.city.trim(),
        state: location.state.trim(),
        zip: location.zipcode.trim()
      },
      phone: location.phoneNumber.trim(),
      coords: {
        lat: parseFloat(location.latitude),
        lng: parseFloat(location.longitude)
      },
      hours: formatHours(location),
      url: location.url.trim(),
      placeUrl: location.placeUrl.trim(),
      imgUrl: getImageSizeUrl(location.imageUrl, 880),
      imgUrlMobile: getImageSizeUrl(location.imageUrl, 460),
      alert: location.alert,
      notice: location.notice,
      atmOnly: location.atmOnly
    };

    data.hoursHtml = getHoursHtml(data);

    acc.push(data);
    return acc;
  }, []);
}
